/**
 * modules/macbook.js
 * Gestion de l'animation MacBook et rotation des onglets
 */
import { Tab } from 'bootstrap';
/**
 * Gestion de l'animation améliorée du MacBook
 */
export function enhanceMacbookAnimation() {
    const lid = document.querySelector('.lid');
    if (!lid) return;
  
    // Attendre la fin de l'animation d'ouverture
    setTimeout(() => {
      lid.classList.add('opened');
    }, 2200); // 1800ms + 400ms (durée + délai)
  }
  
  /**
   * Initialise le mockup MacBook et la rotation des onglets
   */
  export function initMacbookMockup() {
    // Vérifier si on est en version desktop et si l'élément existe
    if (window.innerWidth >= 768 && document.getElementById('nav-tab')) {
      // Référence aux éléments
      const lid = document.querySelector('.lid');
      const screenContent = document.querySelector('.screen-content');
      const screenReflection = document.querySelector('.screen-reflection');
      const keyboardBase = document.querySelector('.keyboard-base');
      const bootScreen = document.querySelector('.boot-screen');
      const bootLogo = document.querySelector('.boot-logo');
      
      if (lid) {
        // Appliquer l'animation d'ouverture
        lid.style.animation = "openLaptopElastic 1.5s cubic-bezier(0.17, 0.84, 0.44, 1.1) forwards";
        
        // Animations subséquentes
        if (keyboardBase) {
          keyboardBase.style.animation = "keyboardLift 1.2s forwards";
          keyboardBase.style.animationDelay = "0.3s";
        }
        
        if (bootLogo) {
          bootLogo.style.animation = "logoAppear 1.2s ease forwards";
          bootLogo.style.animationDelay = "0.5s";
        }
        
        if (bootScreen) {
          bootScreen.style.animation = "fadeOutBoot 0.8s forwards";
          bootScreen.style.animationDelay = "1.8s";
        }
        
        if (screenContent) {
          screenContent.style.animation = "screenGlow 1s ease-in forwards";
          screenContent.style.animationDelay = "2.0s"; // Légèrement plus tard pour éviter de voir le contenu pendant la transition
        }
        
        if (screenReflection) {
          screenReflection.style.animation = "reflectionAppear 0.8s ease-in forwards";
          screenReflection.style.animationDelay = "2.2s";
        }
  
        setupTabRotation();
      }
    }
  }
  
  /**
   * Configurer la rotation automatique des onglets pour le MacBook
   */
  function setupTabRotation() {
    // Variables pour la rotation des onglets
    const tabList = ['nav-tree-tab', 'nav-fan-tab', 'nav-map-tab', 'nav-timeline-tab', 'nav-stats-tab'];
    let currentTabIndex = 0;
    let tabRotationTimer = null;
    let rotationPaused = false;
  
    // Fonction pour passer à l'onglet suivant
    function rotateTab() {
      // Incrémenter l'index et revenir à 0 si nécessaire
      currentTabIndex = (currentTabIndex + 1) % tabList.length;
  
      // Activer le nouvel onglet
      const nextTab = document.getElementById(tabList[currentTabIndex]);
      if (nextTab) {
        const tabTrigger = new Tab(nextTab);
        tabTrigger.show();
      }
    }
  
    // Fonction pour démarrer la rotation
    function startRotation() {
      if (!tabRotationTimer && !rotationPaused) {
        tabRotationTimer = setInterval(rotateTab, 4000);
      }
    }
  
    // Fonction pour arrêter la rotation
    function stopRotation() {
      if (tabRotationTimer) {
        clearInterval(tabRotationTimer);
        tabRotationTimer = null;
      }
    }
  
    // Sélectionner la navigation des onglets et l'écran
    const navTab = document.getElementById('nav-tab');
    const screen = document.querySelector('.screen');
  
    if (!navTab || !screen) return;
  
    // Arrêter la rotation lorsque la souris survole les onglets
    navTab.addEventListener('mouseenter', function () {
      rotationPaused = true;
      stopRotation();
    });
  
    // Marquer que la rotation n'est plus en pause quand la souris quitte les onglets
    navTab.addEventListener('mouseleave', function () {
      rotationPaused = false;
      startRotation(); // Redémarrer la rotation
    });
  
    // Arrêter la rotation lorsque la souris est sur l'écran
    screen.addEventListener('mouseenter', function () {
      stopRotation();
    });
  
    // Redémarrer la rotation lorsque la souris quitte l'écran
    screen.addEventListener('mouseleave', function () {
      if (!rotationPaused) { // Ne redémarrer que si on n'est pas déjà en pause à cause des onglets
        startRotation();
      }
    });
  
    // Arrêter la rotation si l'utilisateur clique sur un onglet
    const allTabs = document.querySelectorAll('[data-bs-toggle="tab"]');
    allTabs.forEach(tab => {
      tab.addEventListener('click', function () {
        // Mettre à jour l'index actuel en fonction de l'onglet cliqué
        currentTabIndex = tabList.indexOf(tab.id);
  
        // La rotation reste arrêtée après un clic (comportement UX amélioré)
        rotationPaused = true;
        stopRotation();
      });
    });
  
    // Démarrer la rotation des onglets après que toutes les animations soient terminées
    setTimeout(function () {
      startRotation();
    }, 2500); // Attendre la fin de toutes les animations (~3.5s + marge)
  }